export default __webpack_public_path__ + "img/dKZDfDXW.d0606378.svg";